import Vue from "vue"
import VueRouter from "vue-router"
import store from '@/store/index.js'
import {
  getRoutePageType,
  getLoginRouteByPageType,
  getHomeRouteByPageType,
  PAGE_TYPE
} from '@/common/pageRouteUtils'

Vue.use(VueRouter)


// 防止路由重复点击报错，
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// 创建路由页面，
const routes = [
  {
    //客户端主页框架
    path: '/',
    name: 'Main',
    meta: { pageType: PAGE_TYPE.PC },
    component: () => import('@/views/main/Main'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Dashboard'),
      },
      {
        path: '/BigScreen',
        name: 'BigScreen',
        component: () => import('@/views/bigscreen/BigScreenList'),
      },
      {
        path: '/BigScreen/:id',
        name: 'BigScreenDetail',
        component: () => import('@/views/bigscreen/BigScreenDetail'),
      },

      {
        path: '/UserReport',
        name: 'UserReport',
        component: () => import('@/views/userreport/UserReport'),
      },
      {
        path: '/UserReportView/:reportid',
        name: 'UserReportView',
        component: () => import('@/views/userreport/UserReportView'),
      },
      {
        path: '/SqbActivate',
        name: 'SqbActivate',
        component: () => import('@/views/setsys/SqbActivate'),
      }
    ]
  },
  {
    //智能登录页面（自动识别设备类型）
    path: '/login',
    name: 'login',
    meta: { pageType: PAGE_TYPE.PC, notoken: true },
    component: () => import('@/views/login/SmartLogin'),
  },
  {
    //错误页面
    path: '/error',
    name: 'error',
    meta: { pageType: PAGE_TYPE.PC, notoken: true },
    component: () => import('@/views/error/Error'),
  },
  {
    //打印页面
    path: '/Print',
    name: 'Print',
    meta: { pageType: PAGE_TYPE.PC },
    component: () => import('@/views/print/Print'),
  },
  {
    //微信公众号登录授权页
    path: '/MobileBinding',
    name: 'MobileBinding',
    meta: { pageType: PAGE_TYPE.MOBILE, notoken: true },
    component: () => import('@/views/wx_mobilebinding/MobileBinding'),
  },
  {
    //移动端数据查看页面（提醒推送等）
    path: '/DataView/:id?',
    name: 'DataView',
    meta: { pageType: PAGE_TYPE.MOBILE, notoken: true },
    component: () => import('@/views/wx_mobilebinding/DataView'),
  },
  {
    // 移动端统一支付页（orderpay 节点 pageDisplayFields）
    path: '/PayView/:id?',
    name: 'PayView',
    meta: { pageType: PAGE_TYPE.MOBILE, notoken: true },
    component: () => import('@/views/wx_mobilebinding/PayView'),
  },
  {
    path: '/MobileForm',
    name: 'MobileForm',
    meta: { pageType: PAGE_TYPE.MOBILE, notoken: true },
    component: () => import('@/views/mobile/MobileForm'),
  },
  {
    path: '/MobileLogin',
    name: 'MobileLogin',
    meta: { pageType: PAGE_TYPE.MOBILE, notoken: true },
    component: () => import('@/views/mobile/MobileLogin'),
  },
  {
    // 小程序 web-view H5 框架
    path: '/HoreLogin',
    name: 'HoreLogin',
    meta: { pageType: PAGE_TYPE.H5, notoken: true },
    component: () => import('@/views/h_login/HoreLogin'),
  },
  {
    path: '/Hcore',
    name: 'Hcore',
    meta: { pageType: PAGE_TYPE.H5, notoken: true },
    component: () => import('@/views/h_core/HoreCore'),
    redirect: '/HoreHome',
    children: [
      {
        path: '/HoreHome',
        name: 'HoreHome',
        meta: { pageType: PAGE_TYPE.H5, notoken: true },
        component: () => import('@/views/h_home/HoreHome'),
      },
      {
        path: '/HoreFunction',
        name: 'HoreFunction',
        meta: { pageType: PAGE_TYPE.H5, notoken: true },
        component: () => import('@/views/h_function/HoreFunction'),
      },
      {
        path: '/HoreMine',
        name: 'HoreMine',
        meta: { pageType: PAGE_TYPE.H5, notoken: true },
        component: () => import('@/views/h_mine/HoreMine'),
      }
    ]
  },
  {
    //e5核心框架页面
    path: '/Ecore',
    name: 'Ecore',
    meta: { pageType: PAGE_TYPE.PC },
    component: () => import('@/views/e_core/Core'),
    redirect: '/EoreHome',
    children: [
      {
        path: '/EoreHome',
        name: 'EoreHome',
        component: () => import('@/views/e_home/EoreHome'),
      },
      {
        path: '/EoreMenu/:id',
        name: 'EoreMenu',
        component: () => import('@/views/e_menu/EoreMenu'),
      },
      {
        path: '/EorePrint/:id',
        name: 'EorePrint',
        component: () => import('@/views/e_print/EorePrint'),
      },
      {
        path: '/EoreForm/:formname?',
        name: 'EoreForm',
        component: () => import('@/views/e_form/EoreForm'),
      },
      {
        path: '/EoreFormEdit',
        name: 'EoreFormEdit',
        component: () => import('@/views/e_formedit/EoreFormEdit'),
      },
      {
        path: '/EoreFormEvent',
        name: 'EoreFormEvent',
        component: () => import('@/views/e_formevent/EoreFormEvent'),
      },
      {
        path: '/EoreDeliver',
        name: 'EoreDeliver',
        component: () => import('@/views/e_deliver/EoreDeliver'),
      },
      {
        path: '/EoreReport/addreport',
        name: 'EoreReportAdd',
        component: () => import('@/views/e_report/EoreReport'),
      },
      {
        path: '/EoreReport/:reportid?',
        name: 'EoreReport',
        component: () => import('@/views/e_report/EoreReport'),
      },
      {
        path: '/EoreReportView/:reportid',
        name: 'EoreReportView',
        component: () => import('@/views/e_report/EoreReportView'),
      },
      {
        path: '/EoreReminder/addreminder',
        name: 'EoreReminderAdd',
        component: () => import('@/views/e_reminder/EoreReminder'),
      },
      {
        path: '/EoreReminder/:reminderid?',
        name: 'EoreReminder',
        component: () => import('@/views/e_reminder/EoreReminder'),
      }
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  routes
})

const LOGIN_ROUTE_NAMES = ['login', 'MobileLogin', 'HoreLogin']

//登录导航守卫
router.beforeEach((to, from, next) => {
  try {
    store.commit('getToken')
    const token = store.state.user.token
    const pageType = getRoutePageType(to)

    if (to.name == null && store.state.tab.menu.length <= 0) {
      next({ name: getLoginRouteByPageType(pageType) })
      return
    }

    // 已登录访问登录页：按页面类型回到对应首页或 redirect
    if (token && LOGIN_ROUTE_NAMES.includes(to.name)) {
      if (to.query && to.query.redirect) {
        next(to.query.redirect)
      } else if (to.name === 'MobileLogin' && from.name === 'MobileForm') {
        next()
      } else if (to.name === 'HoreLogin') {
        next({ name: getHomeRouteByPageType(PAGE_TYPE.H5) })
      } else {
        next({ name: getHomeRouteByPageType(getRoutePageType(to)) })
      }
      return
    }

    // 未登录且需要登录验证：按目标页面类型跳转对应登录页
    if (!token && !to.meta.notoken) {
      router.replace({
        name: getLoginRouteByPageType(pageType),
        query: { redirect: to.fullPath }
      })
      return
    }

    next()
  } catch (error) {
    console.error('路由守卫错误:', error)
    next({ name: 'login' })
  }
})


// 导出路由
export default router
